import { LanguageDictionary } from "../language";

export type WorkshopMenuItemType = 'header' | 'item'

export interface WorkshopMenuItem {
	type: WorkshopMenuItemType
	text: LanguageDictionary<string>
	workshopId?: number
	page?: string
	pageContent?: LanguageDictionary<string>
}

export const insertPublicUrl = (pageContent: string) =>  pageContent.replaceAll('%PUBLIC_URL%', process.env.PUBLIC_URL)